import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H3 } from 'foundations-components/transitional/components/H3';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { useGateOverride, useHasGate, useHasScope, useScopeOverride } from '../../accounts';
import { useDevtools, useRhumbDebug } from '../devtoolsQueries';
import { Select } from 'foundations-components/components/Select';
// @ts-expect-error no types
import SafeStorage from 'SafeStorage';
import { useState } from 'react';
import { Text } from 'foundations-components/components/Text';

// @ts-expect-error adding stuff to the window
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
window.Academy = {};
const gateHelpText = {
  'AcademyCertification:ForcePartnerCertification': "This will enable you to see the UI but the the backend still won't return any Partner content"
};
const GateToggle = ({
  gateName
}) => {
  const [override, setOverride, resetOverride] = useGateOverride(gateName);
  const {
    hasGate
  } = useHasGate(gateName);
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    gap: 16,
    children: [/*#__PURE__*/_jsx(FormControl, {
      help: gateHelpText[gateName],
      label: gateName,
      children: /*#__PURE__*/_jsx(Toggle, {
        checked: override !== null ? override : hasGate || false,
        id: `mySavedItems-${gateName}`,
        onChange: ({
          target: {
            checked
          }
        }) => {
          setOverride(checked);
        }
      })
    }), override !== null && /*#__PURE__*/_jsx(Button, {
      onClick: resetOverride,
      children: "Reset active override"
    })]
  });
};
const scopeHelpText = {
  'academy-playlist-global-assignment': "This will enable you to see the UI but the the backend still won't accept any assignments unless you are a member of 53 with the correct scope"
};
const ScopeToggle = ({
  scopeName
}) => {
  const [override, setOverride, resetOverride] = useScopeOverride(scopeName);
  const {
    hasScope
  } = useHasScope(scopeName);
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    gap: 16,
    children: [/*#__PURE__*/_jsx(FormControl, {
      help: scopeHelpText[scopeName],
      label: scopeName,
      children: /*#__PURE__*/_jsx(Toggle, {
        checked: override !== null ? override : hasScope || false,
        id: `mySavedItems-${scopeName}`,
        onChange: ({
          target: {
            checked
          }
        }) => {
          setOverride(checked);
        }
      })
    }), override !== null && /*#__PURE__*/_jsx(Button, {
      onClick: resetOverride,
      children: "Reset active override"
    })]
  });
};
const RhumbDebuggingToggle = () => {
  const {
    value,
    setDebug
  } = useRhumbDebug();
  return /*#__PURE__*/_jsx(FormControl, {
    help: /*#__PURE__*/_jsxs("span", {
      children: ["Enable", ' ', /*#__PURE__*/_jsx("a", {
        href: "https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#debugging",
        children: "debugging support"
      }), ' ', "for React Rhumb. Reload the page after toggling."]
    }),
    label: "React Rhumb Debug",
    children: /*#__PURE__*/_jsx(Toggle, {
      checked: value || false,
      id: "rhumb-debug-toggle",
      onChange: ({
        target: {
          checked
        }
      }) => {
        setDebug(checked);
      }
    })
  });
};
export const Devtools = () => {
  const {
    isOpen,
    toggle
  } = useDevtools();
  let localStorageTheme = 'canvas-light';
  try {
    localStorageTheme = SafeStorage.getItem('trellis:theme');
  } catch (e) {
    console.error(e);
  }
  const [theme, setTheme] = useState(localStorageTheme);
  return isOpen && /*#__PURE__*/_jsxs(Panel, {
    width: 450,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: toggle
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: "Academy Devtools"
      })
    }), /*#__PURE__*/_jsxs(PanelBody, {
      children: [/*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Override Gates"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "AcademyCertification:ForcePartnerCertification"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "Academy:SimulationEnvironments"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "Academy:LearnByDoing"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "Academy:MyTeam:Playlists"
        })]
      }), /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Override Scopes"
        }), /*#__PURE__*/_jsx(ScopeToggle, {
          scopeName: "academy-playlist-global-assignment"
        }), /*#__PURE__*/_jsx(ScopeToggle, {
          scopeName: "academy-public-playlists-admin"
        }), /*#__PURE__*/_jsx(ScopeToggle, {
          scopeName: "academy-studio-content-management"
        })]
      }), /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Debug Toggles"
        }), /*#__PURE__*/_jsx(RhumbDebuggingToggle, {})]
      }), /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Application Theme"
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: "This option requires a page refresh to be applied."
        }), /*#__PURE__*/_jsx(Select, {
          onSelectedOptionChange: ({
            selectedValues
          }) => {
            try {
              SafeStorage.setItem('trellis:theme', selectedValues[0]);
              setTheme(selectedValues[0]);
            } catch (e) {
              console.error(e);
            }
          },
          options: [{
            text: 'Canvas Light',
            value: 'canvas-light'
          }, {
            text: 'Trellis Light',
            value: 'trellis-light'
          }, {
            text: 'Trellis Dark',
            value: 'trellis-dark'
          }, {
            text: 'Pink Light (Debug)',
            value: 'pink-light'
          }],
          searchable: false,
          selectedValues: [theme]
        })]
      })]
    })]
  });
};